import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

window._ = require('lodash');
window.ConvertCoords = {
    pos0: { x: 0, y: 0, lat: 51.34625069794159, lng: -4.763083516983038 },
    pos1: { x: 100, y: 100, lat: 42.310049435554106, lng: 8.344015545221323 }
};
window.passdata = window.data ? JSON.parse(atob(window.data)) : {};
window.scrollEvents = {};

window.getImage = (image, format = 'original') => {
    switch (typeof image) {
        case 'object':
            return image[format];
        case 'string':
            return image;
        default:
            return '';
    }
}

window.addEventListener('scroll', () => {
    _.forEach(window.scrollEvents, cb => cb());
});

window.Element.prototype.getAttr = function (attr) {
    attr = _.kebabCase(attr);

    if (!this.hasAttribute(attr)) return false;

    const attrValue = JSON.parse(this.getAttribute(attr));

    this.removeAttribute(attr);

    return attrValue;
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
